// @general/demo — frontend surface.
//
// One screen and one band. Everything else the demo does happens before the app
// mounts, in session.js: reading `?m=`, opening a session without a password,
// and remembering that this instance is a demo across a page reload.

export { demoApi } from './api'
export {
  ensureDemoSession, isDemoInstance, demoCatalogue, demoLink, demoFailure,
  requestedModules, requestedLanguage, DEMO_FLAG, demoVisit, leaveDemo,
} from './session'
export { minutesLeft, moduleOfRoute, VISIT_KEY, WARN_MINUTES } from './visit'
export { default as DemoBanner } from './components/DemoBanner.vue'

export const routes = [
  {
    path: '/demo',
    name: 'demo-selector',
    component: () => import('./views/DemoSelectorView.vue'),
    // Public and on the sign-in layout: it is the screen somebody sees BEFORE
    // there is a session, and on a demo instance there is no sign-in to send
    // them to instead.
    meta: { public: true, layout: 'auth', title: 'demo.selector.title' },
  },
]

// No navigation entry. The selector is reached from the band at the top of the
// screen, and a demo's sidebar should show the client's modules — not ours.
export const navigation = []

export default { routes, navigation }
